import StateManagement from "./StateManagement";

export const CreateColumns = (obtainedArr, ele, type) => {
    let finalArr = [];

    // Check if 'id' exists in obtainedArr and add it as the first column
    if (obtainedArr.includes('id')) {
        finalArr.push({
            field: 'id', // Assuming 'id' is the field name
            headerName: 'Serial No.',
            headerClassName: 'header-blue',
            minWidth: 100,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        });
    }

    // Process other columns
    obtainedArr.forEach((element) => {
        const columnName = element.replace(/_/g, " ");

        if (
            element !== "id" &&
            element !== "cmm_id" &&
            // element !== "hytr_id" &&
            element !== "quarter" &&
            // element !== "half_year" &&
            element !== "pmsName" &&
            element !== "fy_year" &&
            element !== "cmm_remarks" &&
            // element !== "hytr_remarks" &&
            element !== "cmm_type" &&
            element !== "cmm_status" &&
            // element !== "hytr_status" &&
            element !== "compliance_status" &&
            element !== "compliance_percentage" &&
            element !== "s3Location" &&
            element !== "cmm_complaint_id" &&
            element !== "uploadedfileName" &&
            element !== "index" &&
            element !== "pmsname"
        ) {
            finalArr.push({
                field: `${element}`,
                headerName: columnName.charAt(0).toUpperCase() + columnName.slice(1),
                headerClassName: "header-blue",
                minWidth: 350,
                flex: 1,
                align: "center",
                headerAlign: "center",
                sortable: false,
            });
        } else if (
            element === "cmm_remarks" ||
            // element === "hytr_remarks" ||
            element === "compliance_status" ||
            element === "compliance_percentage" ||
            element === "complaints_pending_at_the_end_of_the_period" ||
            element === "complaints_at_the_beginning_of_the_period" ||
            element === "complaints_received_during_the_period" ||
            element === "complaints_redressed_during_the_period"
        ) {
            finalArr.push({
                field: `${element}`,
                headerName:
                    element === "cmm_remarks"
                        ? "CMM remarks"
                        : columnName.charAt(0).toUpperCase() + columnName.slice(1),
                headerClassName: "header-blue",
                minWidth:
                    (element === "compliance_status" || element === "compliance_percentage") ? 250 : 350,
                align: "center",
                flex: 1,
                headerAlign: "center",
                sortable: false,
                renderCell: (params) => {
                    return (
                        <>
                            {(element === "cmm_remarks") ? (
                                <StateManagement params={params} type={element} moduleType={type} />
                            ) : element === "compliance_status" ? (
                                <StateManagement params={params} type={"remarks"} moduleType={type} />
                            ) : element === "compliance_percentage" ? (
                                <StateManagement params={params} type={"percentage"} moduleType={type} />
                            ) : (
                                <StateManagement params={params} type={element} moduleType={type} />
                            )}
                        </>
                    );
                },
            });
        }
    });

    // Add Upload details column if not Investor Complaints
    if (ele !== "Investor Complaints") {
        finalArr.push({
            field: "UploadedFile",
            headerName: "Upload details",
            headerClassName: "header-blue",
            minWidth: 250,
            flex: 1,
            align: "center",
            headerAlign: "center",
            sortable: false,
            renderCell: (params) => {
                return (
                    <StateManagement params={params} type={"upload"} moduleType={type} />
                );
            },
        });
    }

    return finalArr;
};

export const CreateColumnsModal = (obtainedArr, ele, type) => {
    let finalArr = [];

    // Check if 'id' exists in obtainedArr and add it as the first column
    if (obtainedArr.includes('id')) {
        finalArr.push({
            field: 'id', // Assuming 'id' is the field name
            headerName: 'Serial No.',
            headerClassName: 'header-blue',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
        });
    }

    obtainedArr.forEach((element) => {
        // Skip adding the ID column again
        if (element === 'id') return;

        let columnName;
        if (element !== 'uploadedfileName') {
            columnName = element.replace(/_/g, ' ');
        }

        if (
          ![  'id',
              'cmm_id', 
            //   'hytr_id', 
              'quarter', 
            //   'half_year', 
              'pmsName', 
              'fy_year', 
              'cmm_type', 
              'cmm_status', 
            //   'hytr_status', 
              's3Location', 
              'cmm_complaint_id', 
              'index', 
              'pmsname'
          ].includes(element)
        ) {
          finalArr.push({
              field: `${element}`,
              headerName:
                  element === 'uploadedfileName'
                      ? 'Uploaded details'
                      : element === 'cmm_remarks'
                      ? 'CMM remarks'
                      : columnName.charAt(0).toUpperCase() + columnName.slice(1),
              headerClassName: 'header-blue',
              align: 'center',
              headerAlign: 'center',
              sortable: false,
              flex: 1,
              renderCell: (params) => {
                  return (
                      <div style={{ whiteSpace: 'pre-wrap' }}>
                          {params.row[`${element}`] !== '' ? params.row[`${element}`] : '-'}
                      </div>
                  );
              },
          });
      }
    });

    return finalArr;
};
